import { ClientJourneyValidationMetadata } from '../../../shared/validation/client-journey-validation-metadata';
import { ModelValidator } from '../../../shared/validation/model-validator';
import { Contact } from '../../../shared/models/deal-resources/contact.model';
import { ValidatorRule } from 'src/app/utilities/validation/validation.interfaces';

export enum RealtorContactValidationRules {
  EmailFormat = 'emailFormat',
}

export class RealtorContactValidator extends ModelValidator<
  Contact,
  ClientJourneyValidationMetadata
> {
  private emailFormatValidationRule: ValidatorRule;
  get emailFormatIsValid(): boolean {
    return this.emailFormatValidationRule.isValid;
  }

  constructor(contact: Contact) {
    super(contact);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: false,
      showInMenu: true,
    };

    //email - format
    this.emailFormatValidationRule = this.ruleFor(
      c => c.email,
      RealtorContactValidationRules.EmailFormat,
      navigationMetadata,
    )
      .when(c => c.email?.length > 0)
      .must(email => {
        let indexOfAt = email?.indexOf('@');
        let lastIndexOfDot = email?.lastIndexOf('.');
        let isValid =
          !!email &&
          indexOfAt > 0 &&
          lastIndexOfDot + 1 < email?.length &&
          lastIndexOfDot - indexOfAt > 1;
        return isValid;
      });
  }
}
